import React from 'react';

/**
 * Skeleton loader específico para el carrito flotante
 */
const FloatingCartSkeleton: React.FC = () => {
  return (
    <div className="fixed bottom-20 right-4 z-40">
      <div className="w-14 h-14 bg-[#22B6B2] rounded-full shadow-lg animate-pulse flex items-center justify-center">
        <div className="w-6 h-6 bg-white/80 rounded animate-pulse"></div>
      </div>
    </div>
  );
};

export default FloatingCartSkeleton; 